import React, { useState, useRef, useEffect } from "react";
import { Modal, Button, Form, Alert, Spinner } from "react-bootstrap";
import { handleTokenAndPostRequest } from "../utils/utils";

export default function ContactVendorleadsModal({ show, onHide }) {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const emailRef = useRef(null);

  useEffect(() => {
    if (show && emailRef.current) emailRef.current.focus();
    if (!show) {
      setEmail("");
      setMessage("");
      setIsLoading(false);
      setSent(false);
      setErrorMessage("");
    }
  }, [show]);

  const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateEmail(email)) {
      setErrorMessage("Please enter a valid email address.");
      return;
    }
    setIsLoading(true);
    setErrorMessage("");
    try {
      await handleTokenAndPostRequest(
        `${window.api_host}/contact-vendorleads`,
        { email, message }
      );
      setSent(true);
    } catch (e) {
      setErrorMessage("Failed to send message. Please try again.");
    }
    setIsLoading(false);
  };

  return (
    <Modal
      style={{ zIndex: 9999 }}
      show={show}
      onHide={onHide}
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>Contact Vendorleads</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {sent ? (
          <Alert variant="success">
            Thank you for reaching out! We'll be in touch soon.
          </Alert>
        ) : (
          <Form onSubmit={handleSubmit}>
            <div style={{
              marginBottom: 24,
              color: "#1a3f6b",
              fontWeight: 400,
              fontSize: "1.05rem"
            }}>
              Discover how the Vendorleads AI Co-Pilot can help you grow your business, win more listings, and get better leads. 
              Reach out and our team will show you how it works.
            </div>
            <Form.Group controlId="contactEmail" style={{ marginBottom: 16 }}>
              <Form.Label>Email address</Form.Label>
              <Form.Control
                type="email"
                placeholder="Your email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                ref={emailRef}
                disabled={isLoading}
              />
            </Form.Group>
            <Form.Group controlId="contactMessage" style={{ marginBottom: 16 }}>
              <Form.Label>Message</Form.Label>
              <Form.Control
                as="textarea"
                rows={4}
                placeholder="How can we help you?"
                value={message}
                onChange={e => setMessage(e.target.value)}
                disabled={isLoading}
              />
            </Form.Group>
            {errorMessage && <Alert variant="danger">{errorMessage}</Alert>}
            <Button
              type="submit"
              disabled={isLoading}
              style={{
                width: "100%",
                border: "none",
                borderRadius: "6px",
                padding: "0.7rem 1.5rem",
                fontSize: "1rem",
                fontWeight: 600,
                cursor: "pointer",
                transition: "all 0.2s ease-in-out",
                boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                textDecoration: "none",
                background: "linear-gradient(90deg, #1a3f6b, #10b981)",
                color: "#fff"
              }}
            >
              {isLoading ? (
                <>
                  <Spinner animation="border" size="sm" style={{ marginRight: 10 }} />
                  <span>Contact Vendorleads</span>
                </>
              ) : (
                "Contact Vendorleads"
              )}
            </Button>
          </Form>
        )}
      </Modal.Body>
    </Modal>
  );
}